export const URL_RISK_WARNING: Record<string, string> = {
  en: 'https://cdn.bitpanda.com/terms-and-conditions/risk-information-financial-instruments-bitpanda-en-1.0.0.pdf',
  de: 'https://cdn.bitpanda.com/terms-and-conditions/risk-information-financial-instruments-bitpanda-de-1.0.0.pdf',
  fr: 'https://cdn.bitpanda.com/terms-and-conditions/risk-information-financial-instruments-bitpanda-fr-1.0.0.pdf',
  it: 'https://cdn.bitpanda.com/terms-and-conditions/risk-information-financial-instruments-bitpanda-it-1.0.0.pdf',
};
